import templateOnly from '@ember/component/template-only';
import fuiDropdown from 'wise-fui-modules/modifiers/fui-dropdown';
import { on } from '@ember/modifier';
import { fn } from '@ember/helper';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
const dropdownButtonBaseButtonItem = setComponentTemplate(precompileTemplate("\n  <div class=\"item\" role=\"button\" data-test={{if @dataTestValue @dataTestValue @key}} {{on \"click\" (fn @onClick @key)}} ...attributes>\n    {{yield}}\n  </div>\n", {
  strictMode: true,
  scope: () => ({
    on,
    fn
  })
}), templateOnly(undefined, "dropdown-button-base:dropdownButtonBaseButtonItem"));
const DropdownButtonBaseComponent = setComponentTemplate(precompileTemplate("\n  <div ...attributes>\n    <div class=\"flex flex-col gap-2\">\n      <div class=\"text-p1 text-grey\">\n        {{yield to=\"label\"}}\n      </div>\n\n      <div {{!-- @glint-expect-error the Signature of FuiModule needs to be updated since now, it requires a first position string arg\u2026--}} {{fuiDropdown action=\"hide\" transition=\"drop\"}} class=\"ui floating dropdown item [&.ui.floating.dropdown.item]:ml-auto [&.ui.floating.dropdown.item]:w-[max-content]\">\n        {{yield to=\"button\"}}\n        <div class=\"menu {{if @alignMenuLeft \"left\"}}\">\n          {{yield (component dropdownButtonBaseButtonItem onClick=@onClick) to=\"items\"}}\n        </div>\n      </div>\n    </div>\n  </div>\n", {
  strictMode: true,
  scope: () => ({
    fuiDropdown,
    dropdownButtonBaseButtonItem
  })
}), templateOnly(undefined, "dropdown-button-base:DropdownButtonBaseComponent"));
export default DropdownButtonBaseComponent;